import React from "react";
import { Outlet } from "react-router";

const PollPage = () => {
  return <Outlet />;
};

export default PollPage;
